$(document).ready(function () {
  $(".brands_inner").slick({
    dots: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 300
    // centerMode: true,
    // centerPadding: "0px"
  });
    $(".hero_slider_inner").slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1200,
    arrows: true,
   autoplay: true,
  autoplaySpeed: 2000,
  });

    $('.carousel').slick({
  slidesToShow: 3,
  dots:true,
  centerMode: true,
  });

      $(".main_slider").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    prevArrow: $(".arrow_testimonial_slide .arrow_right"),
    nextArrow: $(".arrow_testimonial_slide .arrow_left"),
  });

  // $(window).scroll(function() {
  //   if ($(document).scrollTop() > 600) {
  //     $(".custom-filter").addClass("sticky");
  //   } else {
  //     $(".custom-filter").removeClass("sticky");
  //   }
  // });
  
});

 
